import { ViewTaskItem } from '../model/view-task-item.model';

export function filterByKeyword(
    keyword: string | null,
    items: ViewTaskItem[],
): ViewTaskItem[] {
    if (keyword == null || keyword.trim().length === 0) {
        return [...items];
    }

    return items.filter((e) => {
        const kw = keyword.toLowerCase();
        return e.title?.toLowerCase().includes(kw);
    });
}
